export default "/images/numbers-photo2.jpg";